import { v4 as uuidv4 } from 'uuid';
import axiosInstance from '../axios';

class TransactionInfo{
    static async getTrxInfo(){
        let trxInfo = await axiosInstance.get(`/api/getalldata`)
        if(trxInfo){
            return trxInfo.data
        }else {
            return []
        }
    }

    static addTrxInfo(data){
        data.id = uuidv4()
        localStorage.setItem('trxInfo', JSON.stringify(data))
    }


}
export default TransactionInfo;